<template>
  <v-app id="inspire">
    <div v-if="$route.meta.plainLayout">
      <router-view />
    </div>
    <div v-if="!$route.meta.plainLayout">
      <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
        <v-list dense>
          <template v-for="item in items">
            <v-row v-if="item.heading" :key="item.heading" link :to="item.link" align="center">
              <v-col cols="6">
                <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
                <!-- <v-subheader v-if="item.heading">{{ item.route }}</v-subheader> -->
              </v-col>
              <v-col cols="6" class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.link">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else :key="item.text" link :to="item.link">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 200px" class="ml-0 pl-1">
          <span class="hidden-sm-and-down">SpookApp</span>
        </v-toolbar-title>
        <v-col style="width: 300px" class="pt-4 mt-6">
          <v-select
          v-model="deviceSelected"
            :items="devices"
            label="Devices"
            outlined
            prepend-inner-icon="mdi-view-dashboard"
            item-text="manufacturer"
            item-value="mobileUniqueID"
            @change="changeMobile()"
          ></v-select>
        </v-col>
        <v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
          class="hidden-sm-and-down"
        />
        <v-spacer />
        <v-btn icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
        <v-btn icon large>
          <v-avatar size="32px" item>
            <v-img src="https://cdn.vuetifyjs.com/images/logos/logo.svg" alt="Vuetify" />
          </v-avatar>
        </v-btn>
      </v-app-bar>
      <v-content>
        <v-container class="fill-height" fluid>
          <!-- <CrudVue/>         -->
          <!-- route outlet -->
          <!-- component matched by the route will render here -->

          <router-view></router-view>
          <!-- <ListItemVue/>
        <AuthVue/>
        <googleVue/>
        <FileuploadFirebaseVue/>
        <FlashLightVue/>
        <mail-vue/>
        <call-logs-vue/>
        <contact-list-vue/>
          <map-vue/>-->
        </v-container>
      </v-content>
      <v-btn bottom color="pink" dark fab fixed right @click="dialog = !dialog">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" width="800px">
        <v-card>
          <v-card-title class="grey darken-2">Create contact</v-card-title>
          <v-container>
            <v-row class="mx-2">
              <v-col class="align-center justify-space-between" cols="12">
                <v-row align="center" class="mr-0">
                  <v-avatar size="40px" class="mx-3">
                    <img src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png" alt />
                  </v-avatar>
                  <v-text-field placeholder="Name" />
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  prepend-icon="mdi-account-card-details-outline"
                  placeholder="Company"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field placeholder="Job title" />
              </v-col>
              <v-col cols="12">
                <v-text-field prepend-icon="mdi-mail" placeholder="Email" />
              </v-col>
              <v-col cols="12">
                <v-text-field type="tel" prepend-icon="mdi-phone" placeholder="(000) 000 - 0000" />
              </v-col>
              <v-col cols="12">
                <v-text-field prepend-icon="mdi-text" placeholder="Notes" />
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-btn text color="primary">More</v-btn>
            <v-spacer />
            <v-btn text color="primary" @click="dialog = false">Cancel</v-btn>
            <v-btn text @click="mymethod()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
// import CrudVue from './components/Crud.vue';
// import ListItemVue from './components/ListItem.vue';
// import AuthVue from './components/Auth.vue';
// import googleVue from './components/google.vue';
// import FileuploadFirebaseVue from './components/FileuploadFirebase.vue';
// import FlashLightVue from './components/FlashLight.vue';
// import MailVue from './components/Mail.vue';
// import CallLogsVue from './components/CallLogs.vue';
// import ContactListVue from './components/ContactList.vue';
// import MapVue from './components/Map.vue';
import { theUserDevicesList } from "../firebaseConfig";
import { store } from '../store';
export default {
  name: "App",
  components: {
    // CrudVue,
    // ListItemVue,
    // AuthVue,
    // googleVue,
    // FileuploadFirebaseVue,
    // FlashLightVue,
    // MailVue,
    // CallLogsVue,
    // ContactListVue,
    // MapVue
  },
  props: {
    source: String
  },
  data: () => ({
    deviceSelected:null,
    dialog: false,
    drawer: true,
    devices: [],
    kns:'',
    items: [
      { icon: "mdi-home", text: "Home", link: "/home" },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Fun",
        model: false,
        children: [
          { icon: "mdi-flash", text: "Flashlight", link: "/flashlight" },
          { icon: "mdi-music-note", text: "Music", link: "/music" },
          { icon: "mdi-vibrate", text: "Vibration", link: "/vibration" },
          { icon: "mdi-brightness-4", text: "Brightness", link: "/brightness" },
          {
            icon: "mdi-bluetooth-settings",
            text: "Bluetooth",
            link: "/bluetooth"
          },
          { icon: "mdi-speaker", text: "Sound", link: "/sound" },
          { icon: "mdi-camera-iris", text: "Camera Open", link: "/camera" },
          { icon: "mdi-wifi", text: "Hotspot", link: "/hotspot" },
          {
            icon: "mdi-image-filter-center-focus",
            text: "ScreenShot",
            link: "/screenshot"
          }
        ]
      },
      { icon: "mdi-magnify", text: "Turbo Search", link: "/turbo-search" },
      { icon: "mdi-contacts", text: "Contacts", link: "/contact-list" },
      { icon: "mdi-phone-in-talk", text: "On Call", link: "/on-call" },
      { icon: "mdi-message", text: "SMS", link: "/sms" },
      { icon: "mdi-phone", text: "Call Logs", link: "/call-logs" },
      { icon: "mdi-whatsapp", text: "WhatsApp", link: "/whatsapp" },
      { icon: "mdi-instagram", text: "Instagram", link: "/instagram" },
      { icon: "mdi-shopping-music", text: "Install App", link: "/install-app" },
      { icon: "mdi-crosshairs-gps", text: "Location", link: "/map" },
      { icon: "fas fa-cog", text: "Settings", link: "/setting" },
      { icon: "mdi-help-circle", text: "Help", link: "/help" }
    ]
  }),

  mounted: function() {
    this.getObj();
  },
  methods: {
    mymethod() {
      alert("hello world");
    },
    changeMobile(){
alert(this.deviceSelected);
console.log(this.deviceSelected);
store.state.lists=this.deviceSelected;
    },
    getObj() {
      const self = this;
      theUserDevicesList
        .orderByChild("email")
        .equalTo("tixmotion@gmail.com")
        .once("value")
        .then(
          (snap)=> {
            if (snap.val()) {
              snap.forEach(function(data) {
                self.devices.push(data.val());               
              });
            } else {
              console.log("/whatever/whateverProperty node does not exist!");
            }
            // console.log(snapshot.val());
          },
          function(error) {
            // The Promise was rejected.
            console.log(error);
          }
        );
    }
  }
};
</script>
